export default "__VITE_ASSET__9ded71d9__"